import { ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ApplicationService } from "../../../../services/application/application.service";
import { ErrorService } from "../../../../services/error/error.service";
import { SplashService } from "../../../../services/splash/splash.service";
import { UserService } from "../../../../services/user/user.service";



@Component({
    selector: 'app-email-test',
    styleUrls: ['email-test.component.scss'],
    templateUrl: 'email-test.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailTestComponent implements OnDestroy {
    private _subRelease: Subject<void> = new Subject<void>();

    message = 'Test Message';
    email = '';
    selectedEmailTemplate = 'DELTAAutomatedMessage';
    
    ListOfEmailTemplates = [
        // { value: 'DELTACounselorStudentChangeNotification', label: 'Counselor Student Change Notification' },
        // { value: 'DELTAAdvisorNotification', label: 'Advisor Notification' },
        { value: 'DELTAAutomatedMessage', label: 'Automated Message' },
        { value: 'DELTANewDesigneeAccount', label: 'New Designee Account' },
        { value: 'DELTANewIssueReport', label: 'New Issue Report' },
        { value: 'DELTANewUserAccount', label: 'New User Account' },
        { value: 'DELTAScheduleReferenceNumberUpdate', label: 'Schedule Reference Number Update' },
    ];

    constructor(
        private appService: ApplicationService, 
        private errorService: ErrorService, 
        private splashService: SplashService,
        private userService: UserService,
    ) 
    { }

    ngOnDestroy() {
        this._subRelease.next();
        this._subRelease.complete();
    }

    consoleLog(emailTemplate: string, email: string, emailMessage: string | null = null) {
        const authToken = this.userService.User.AuthToken;
        console.log('values', {
            authToken,
            email,
            emailMessage,
            emailTemplate,
            selectedEmailTemplate: this.selectedEmailTemplate
        })
    }

    // #region Test Email

    TestEmail(emailTemplate: string, email: string, emailMessage: string | null = null) {
        const authToken = this.userService.User.AuthToken;
        const message = emailMessage && emailMessage.length > 0 ? emailMessage : null;
        // this.consoleLog(
        //     emailTemplate,
        //     email,
        //     emailMessage,
        // )

        this.appService
            .TestEmail(authToken, emailTemplate, email, message)
            .pipe(takeUntil(this._subRelease))
            .subscribe(
                result => result ? this.splashService.SnackbarSuccess(`Tested Email for template "${emailTemplate}" Successfully.`) : this.splashService.SnackbarAlert('Suceeded by also failed?'),
                error => this.errorService.HandleServiceError(error)
            );
    }

    // #endregion
}


// WEBPACK FOOTER //
// ./src/app/admin-settings/components/email-test/email-test.component.ts